export default __webpack_public_path__ + "static/media/package_returned.0af42fbb.png";